import TaxDisclaimerComponent from "./TaxDisclaimer.Component";

export default TaxDisclaimerComponent;
